var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3871 0.237466L6.82258 5.55673C6.8871 5.62005 6.93269 5.68865 6.95936 5.76253C6.98645 5.83641 7 5.91557 7 6C7 6.08443 6.98645 6.16359 6.95936 6.23747C6.93269 6.31135 6.8871 6.37995 6.82258 6.44327L1.3871 11.7784C1.23656 11.9261 1.04839 12 0.82258 12C0.596774 12 0.403226 11.9208 0.241935 11.7625C0.0806451 11.6042 5.07467e-08 11.4195 6.92001e-08 11.2084C8.76534e-08 10.9974 0.0806452 10.8127 0.241935 10.6544L4.98387 6L0.241936 1.34565C0.0913987 1.19789 0.0161295 1.01594 0.0161295 0.799789C0.0161295 0.583219 0.0967751 0.395778 0.258065 0.237466C0.419355 0.0791553 0.607528 -5.58848e-07 0.822581 -5.40047e-07C1.03764 -5.21247e-07 1.22581 0.0791554 1.3871 0.237466Z",
    fill: "#637381"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.25c422ee267b6e09bf927fd54132cf58.svg";
export { ForwardRef as ReactComponent };